import { Group, List, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconExclamationCircleFilled } from '@tabler/icons-react';

interface IntegrityMissingLrnsProps {
  missingLrns: string[];
}

export const IntegrityMissingLrns: React.FC<IntegrityMissingLrnsProps> = ({ missingLrns }) => {
  const theme = useMantineTheme();
  return (
    <Stack gap="md">
      <Group>
        <IconExclamationCircleFilled color={theme.colors.red[6]} />
        <Text size="sm" c="dimmed">
          The following LRNs are missing sequence 1:
        </Text>
      </Group>
      {missingLrns.length > 0 ? (
        <List size="sm">
          {missingLrns.map((lrn: string, lrnIdx: number) => (
            <List.Item key={lrnIdx}>{lrn}</List.Item>
          ))}
        </List>
      ) : (
        <Text size="sm" c="dimmed">
          No missing LRNs found.
        </Text>
      )}
    </Stack>
  );
};
